<div class="default-container">
    <div class="wrapper">
        <div class="container-breadcrumbs">
            <a class="back-to-external-app" [href]="callbackUrl" *ngIf="externalApp && callbackUrl">
                {{ 'SUMMARY.EXTERNAL_APP.CALLBACK_URL' | translate }}
            </a>
            <ng-container *ngIf="!callbackUrl">
                <app-breadcrumbs
                    formerPage="{{
                        (hasConfiguration ? 'COMMON.BREADCRUMBS.CONFIGURATION' : 'COMMON.BREADCRUMBS.PLANNING_PROJECT')
                            | translate
                    }}"
                    currentPage="{{ 'COMMON.BREADCRUMBS.SUMMARY' | translate }}"
                    [navigateTo]="
                        hasConfiguration ? '/configuration' : ['../', 'planning-project', salesforceIdForPlanning]
                    "
                    [queryParams]="navigationParams"
                ></app-breadcrumbs>
            </ng-container>
        </div>
        <div class="container-content" *ngIf="!isLoading">
            <div class="content-content">
                <div class="content-header">
                    <h2>
                        {{ 'SUMMARY.TITLE' | translate }}
                    </h2>
                </div>
                <div
                    class="info-item info-warning"
                    *ngIf="hasProductErrors | async"
                    [innerHTML]="'COMMON.ERRORS.PRODUCT_NOT_AVAILABLE' | translate"
                ></div>
                <div class="content-item">
                    <app-product-table [dataSource]="dataSource" [sampleOffer]="sampleOfferId"></app-product-table>
                </div>
                <div class="content-item">
                    <app-scheme-preview *ngIf="primaryScheme" [primaryScheme]="primaryScheme"></app-scheme-preview>
                </div>
                <div class="content-item content-print" *ngIf="!isLoading && availablePrintTypes?.length">
                    <div class="print-header">
                        <h3>{{ 'SUMMARY.PRINT_TYPE.LABEL' | translate }}</h3>
                    </div>
                    <div class="print-content">
                        <mat-radio-group
                            aria-labelledby="printType"
                            [(ngModel)]="printType"
                            fxLayoutAlign="space-between center"
                        >
                            <mat-radio-button *ngFor="let type of availablePrintTypes" [value]="type">
                                {{ 'SUMMARY.PRINT_TYPE.TYPES.' + type | translate }}</mat-radio-button
                            >
                        </mat-radio-group>
                    </div>
                </div>
                <div class="content-toolbar">
                    <div *ngIf="!isLoading" class="toolbar-button-group">
                        <ng-container *ngIf="!externalApp">
                            <button mat-stroked-button color="primary" (click)="navigateBackToConfiguration()">
                                {{ 'SUMMARY.BUTTON.BACK_TO_CONFIGURATION' | translate }}
                            </button>
                        </ng-container>
                        <a
                            mat-stroked-button
                            color="primary"
                            [routerLink]="['../', 'planning-project', salesforceIdForPlanning]"
                            *ngIf="planning"
                        >
                            {{ 'SUMMARY.BUTTON.PLANNING.BACK_TO_PROJECT_OVERVIEW' | translate }}</a
                        >
                    </div>
                    <button
                        mat-raised-button
                        color="primary"
                        [disabled]="
                            (priceSummaryIsLoading() | async)?.value ||
                            (hasProductErrors | async) ||
                            !selectedCustomerId ||
                            productListEmpty
                        "
                        (click)="closeOffer()"
                    >
                        {{ 'SUMMARY.BUTTON.COMPLETE_CONFIGURATION' | translate }}
                    </button>
                </div>
            </div>
            <div class="content-sidebar">
                <div class="sidebar-sticky">
                    <mat-form-field *ngIf="salesforceIdControl">
                        <input
                            matInput
                            type="text"
                            name="salesforceId"
                            [formControl]="salesforceIdControl"
                            [placeholder]="'SUMMARY.SALESFORCE_ID.PLACEHOLDER' | translate"
                        />
                        <mat-icon matPrefix>edit</mat-icon>
                    </mat-form-field>
                    <app-customer-selection
                        [showClearButton]="externalApp"
                        class="customer-selection-container"
                        *ngIf="permissionService.isUserAnEmployee && !isLoading"
                    ></app-customer-selection>
                    <div class="sidebar-price">
                        <mat-card>
                            <app-price-summary
                                fxFlex
                                [dataSource]="dataSource"
                                [isSummaryPage]="true"
                                [sampleOfferId]="sampleOfferId"
                                (voucherCodeChanged)="updateVoucherCode($event)"
                            ></app-price-summary>
                        </mat-card>
                    </div>
                </div>
            </div>
        </div>
        <app-loader main *ngIf="isLoading" [message]="'SUMMARY.LOADER.FINALIZE_OFFER' | translate"></app-loader>
    </div>
</div>
